/** The service's types, generated from `openapi/openapi.yaml`.
 *
 *  These were hand-written for the whole build, and D2 said they should not be.
 *  The cost of that was measured rather than theoretical: `WireCalendarEvent`
 *  was missing `organizer`, `attendees`, `attendees_omitted`, `time_zone` and
 *  `visibility` — every field the event-detail screen exists to show — so there
 *  was no event-detail screen for a collection the service had supported all
 *  along.
 *
 *  This file is now aliases only. The names stay because every screen imports
 *  them; the shapes come from the document. Regenerate with
 *  `npm run generate:api`, which `npm run check:api` verifies is current.
 *
 *  Nothing here is edited by hand. If a type is wrong, `openapi/openapi.yaml` is
 *  wrong, and `tests/api_contract.rs` is where that gets caught.
 */

import type { components } from './generated/openapi';

type Schemas = components['schemas'];

export type EntryKind = Schemas['EntryKind'];
export type EntryState = Schemas['EntryState'];

export type WireEntry = Schemas['Entry'];
export type WireDay = Schemas['DayProjection'];

export type WireCalendarPerson = Schemas['CalendarPerson'];
export type WireCalendarEvent = Schemas['CalendarEvent'];
export type WireEventRange = Schemas['CalendarEventRange'];

/** One habit's status inside a tracker range. The tracker's `items` are
 *  `HabitStatus`, which carries more than the four fields this client reads. */
export type WireHabit = Schemas['HabitStatus'];
export type WireTracker = Schemas['HabitTracker'];

export type WireReflection = Schemas['Reflection'];
export type WireCapabilities = Schemas['Capabilities'];
export type WireCapturePreview = Schemas['CapturePreview'];

export type WireReadingLogItem = Schemas['ReadingLogItem'];
export type WireGratitudeEntry = Schemas['GratitudeLogEntry'];

export type WireCommonplaceBook = Schemas['CommonplaceBook'];
export type WireCommonplaceEntry = Schemas['CommonplaceEntry'];

/** Streams, projects and contexts are three schemas, not one shape.
 *
 *  This was a single hand-written interface with everything optional, which is
 *  how `project_count` and `stream` came to be `?` on a type that also described
 *  contexts. The union keeps the screens working while making the difference
 *  visible: a project has `status` and `stream`, a stream has `project_count`,
 *  a context has neither.
 */
export type WireTaskStream = Schemas['TaskStream'];
export type WireTaskProject = Schemas['TaskProject'];
export type WireTaskContext = Schemas['TaskContext'];
export type WireTaskMetadata = WireTaskStream | WireTaskProject | WireTaskContext;

/** Every collection off.
 *
 *  `?? {}` was widening `collections` until it could not be indexed. An empty
 *  object is also the wrong default in substance: an unknown capability is not
 *  an enabled one, and this states that rather than implying it.
 */
export const ALL_COLLECTIONS_OFF: Schemas['CollectionSettings'] = {
  habits: false,
  reading_log: false,
  gratitude_log: false,
  commonplace_books: false,
};

/** What the capture sheet displays, which is not quite what the service returns.
 *
 *  `CapturePreview` carries a date-xor-month invariant as a `oneOf`: exactly one
 *  of `resolved_date` and `resolved_month` is set. The service always satisfies
 *  it. A preview computed on the device cannot — offline with no cached journal
 *  date, neither placement is known, and the honest answer is "both null".
 *
 *  So the sheet reads this view model instead. A real `CapturePreview` is
 *  structurally assignable to it, so the server path is unaffected; only the
 *  offline approximation stops claiming to be something it is not. Typing the
 *  local preview as the service's own type was the original mistake, and the
 *  generated `oneOf` is what surfaced it.
 */
export interface DisplayPreview {
  kind: EntryKind;
  content: string;
  resolved_date: string | null;
  resolved_month: string | null;
  stream: string | null;
  project: string | null;
  contexts: string[];
  priority: boolean;
}
